import { PostSubmissionLoadingView } from './components/consumer-post-submission-loading-view/consumer-post-submission-loading-view.component'

export const ConsumerPostSubmissionLoading = () => {
  return <PostSubmissionLoadingView />
}
